<template>
  <span>
    <span v-if="time">
      Posts imported up until {{ $filters.datetime(time) }}
    </span>
    <app-user v-else v-slot="{ isCustomer }">
      <span v-if="isCustomer">No posts have been imported</span>
    </app-user>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppUser from '@/auth/AppUser.vue';

export default defineComponent({
  components: { AppUser },
  props: {
    time: String,
  },
});
</script>
